// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"bf964609","644":"cbe79d9d"}[chunkId] + ".chunk.js";
};